import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content main" }
const _hoisted_2 = { class: "content side" }

import propsObject from "@/props/baseCollapsible";
//import vue
import { computed } from "vue";
//import composables
import {
  useToggle,
  usePrioritizeFlags,
  useMProp,
  useProp,
} from "@toolsie/composables";

//define the props and the emits

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "BaseCollapsible",
  inheritAttrs: true,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: propsObject,
  emits: ["update:active"],
  setup(__props, { emit: emits }: { emit: ({ (e: "update:active", value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props;

//import props



//define the active state and the toggler
let active = useMProp(props, "active", false, emits, "update:active");
let { toggle } = useToggle(active);

let horizontal = useProp(props, "horizontal", false);
let vertical = useProp(props, "vertical", false);
//obtain the default state
let state = usePrioritizeFlags(
  "vertical",
  { vertical: vertical },
  { horizontal: horizontal }
);

//get the object that define the classes
let classes = computed(() => {
  return {
    vertical: state.value == "vertical",
    horizontal: state.value == "horizontal",
    active: active,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toolsie collapsible container", _unref(classes)]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggle)()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "main")
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "side")
    ], 512), [
      [_vShow, _unref(active)]
    ])
  ], 2))
}
}

})